// extracted by mini-css-extract-plugin
export default {"numberOfObjectsWrapper":"numberOfObjectsWrapper---KpI4i"};